import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { useCourseDropdown } from "../../../../query/hooks/QueryHooksCourseAdministration";
import { GetCoursesToLink } from "../../../../services/AssessmentService";
import { GetCourselist } from "../../../../services/DashBoardServices";
import { RenderCourseType, RenderLearningMethod, RenderSchool } from "../../../../utils/CommonGroupingItem";
import { TABLE_DATE_FORMAT } from "../../../../utils/Constants";
import PermissionsGate from "../../../../utils/permissionGate";
import DataTableComponent from "../../../common/DataTableComponent";

const LinkCourseModal = ({ setLinkCourseData, linkCourseData, linkCheckedAllRows, setLinkCheckedAllRows, handleRefreshCourseList, sickAssessmentId, formik }) => {

    const { id, tab, type, subId, subTab } = useParams();
    const [loading, setLoading] = useState(false);
    const [tableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "start",
        sortOrder: "DESC"
    });
    const [search, setSearch] = useState("");
    const [courseData, setCourseData] = useState([]);
    const [learningMethod, setLearningMethod] = useState({ arr: [], checkObj: {} });
    const [programmeIds, setProgrammeIds] = useState({ arr: [], checkObj: [] });
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [school, setSchool] = useState({ arr: [], checkObj: {} });
    const [courseType, setCourseType] = useState({ arr: [], checkObj: {} });
    const [courseStartDate, setCourseStartDate] = useState("");
    const [courseEndDate, setCourseEndDate] = useState("");
    const [courseDateRange, setCourseDateRange] = useState({ startDate: null, endDate: null });
    const [totalRows, setTotalRows] = useState(0);
    const [resetModal, setResetModal] = useState(false);
    
    const { data: courseDropdownRaw } = useCourseDropdown({
        viaStatus: [],
        viaLinkedIntake: 1,
        hasNoAssignedIntake: 1,
        assessment_id: subId
    });

    const courseDropdown = useMemo(() => ({
        programme: courseDropdownRaw.programme ?? [],
        intake: courseDropdownRaw.yearsAndIntaks ?? [],
        learning: courseDropdownRaw.intakeType ?? [],
        school: courseDropdownRaw.schoolType ?? [],
        type: courseDropdownRaw.subjectTypeFilter
            ? courseDropdownRaw.subjectTypeFilter.filter(
                opt => opt.value !== "shortcourse"
            )
            : []
    }), [courseDropdownRaw]);

    const modalClose = () => {
        setLearningMethod({ arr: [], checkObj: {} });
        setProgrammeIds({ arr: [], checkObj: [] });
        setIntake({ arr: [], checkObj: {} });
        setSchool({ arr: [], checkObj: {} });
        setCourseType({ arr: [], checkObj: {} });
        setCourseDateRange({ startDate: null, endDate: null });
        setCourseStartDate("");
        setCourseEndDate("");
        setResetModal(true);
        $("#link-course-modal").modal("hide");
    }

    const exportData = (fileType, fileName) => {
        let data;
        let header = [
            "Name",
            "Start",
            "End",
            "Learning Method",
            "Programme",
            "Intake",
            "School",
            "Type"
        ];

        Swal.fire({
            title: "File downloading",
            didOpen: function () {
                Swal.showLoading();
            },
        });

        let data1 = {
            pageNo: tableState.page,
            size: tableState.perPage,
            intake: intake.arr,
            viaLearnType: learningMethod.arr,
            exportStatus: "true",
            viaStatus: [],
            viaLinkedIntake: 1,
            key: tableState.sortKey,
            sort: tableState.sortOrder,
            viaProgramme: programmeIds.arr,
            viaSearch: search,
            viaSchoolType: school.arr,
            viaSubjectType:courseType.arr?.length > 0 ? courseType.arr : [],
            viaStartDate: courseStartDate ? moment(courseStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaEndDate: courseEndDate ? moment(courseEndDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaRangeStartDate: courseDateRange?.startDate && courseDateRange?.endDate ? moment(courseDateRange?.startDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaRangeEndDate: courseDateRange?.startDate && courseDateRange?.endDate ? moment(courseDateRange?.endDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            showing: [],
            hasNoAssignedIntake: 1,
            assessment_id: subId,
            intake_id: id,
        };
        GetCourselist(data1)
            .then((res) => {
                data = res.data.result;
                data = data?.map((row) => ({
                    Name: row.name,
                    "Start": row.start
                        ? `${moment.unix(row.start).format(TABLE_DATE_FORMAT)}`
                        : "-",
                    "End": row.end
                        ? `${moment.unix(row.end).format(TABLE_DATE_FORMAT)}`
                        : "-",
                    "Learning Method": row.type ? RenderLearningMethod(row.type).text : "-",
                    Programme: row.qualificationName ? row.qualificationName : "-",
                    Intake: `${row.year} - ${row.number}`,
                    School: row.school_type ? RenderSchool(row.school_type).text : "-",
                    Type: row.subject_type ? RenderCourseType(row.subject_type).text : "-",
                }));

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);

                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = [
                        "text/csv",
                        anchor.download,
                        anchor.href,
                    ].join(":");
                    anchor.click();

                    setTimeout(() => {
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                    Swal.close();
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.forEach((col, index) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, { header });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    return false;
                } else if (fileType === "pdf") {
                    const compatibleData = data.map((row) => {
                        return [
                            row["Name"],
                            row["Start"],
                            row["End"],
                            row["Learning Method"],
                            row["Programme"],
                            row["Intake"],
                            row["School"],
                            row["Type"]
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch((error) => {
                console.error("error >>>>>> ", error);
            });
    };

    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "name",
            sortField: "name",
            sortable: true,
            cell: (row) => (
                <div className="assigned-title-block-new">
                    <div
                        className="assigned-title-itm overflow-ellipsis2 fst_line2"
                        title={row.name}
                        onClick={(e) => {
                            if (linkCheckedAllRows.includes(row?.id)) {
                                Swal.fire({
                                    icon: "error",
                                    title: "Already Assigned",
                                    text: "This course is already assigned.",
                                    // timer: 2000,
                                    showConfirmButton: true,
                                });
                                return;
                            }

                            const modifiedRow = { ...row, newData: true, selectedTemplate: {}, weight: "" };
                            setLinkCourseData((prev) => [...prev, modifiedRow]);
                            setLinkCheckedAllRows((prev) => [...prev, row?.id]);
                        }}
                        style={{ cursor: "pointer" }}
                    >
                        <span className="as-text-blue curser textLimit150">
                            {row.name}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            name: "Start",
            selector: "start",
            sortField: "startdate",
            sortable: true,
            cell: (row) => (
                <>
                    {row.start ? (
                        <>
                            <p className="right-space">
                                {moment.unix(row.start).format(TABLE_DATE_FORMAT)}
                            </p>
                        </>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "End",
            selector: "end",
            sortable: true,
            sortField: "enddate",
            cell: (row) => (
                <>
                    {row.end ? (
                        <>
                            <p className="right-space">
                                {moment.unix(row.end).format(TABLE_DATE_FORMAT)}
                            </p>
                        </>
                    ) : (
                        "-"
                    )}
                </>
            ),
        },
        {
            name: "Learning Method",
            selector: "study_type",
            sortable: true,
            sortField: "type",
            cell: (row) => (
                <p className="learningMethodText">
                    {row && row.type ? RenderLearningMethod(row.type).html : "-"}
                </p>
            ),
        },
        {
            name: "Programme",
            selector: "qualificationName",
            sortable: true,
            sortField: "programme",
            cell: (row) => (
                <div className="assigned-title-block-new">
                    <div
                        className="assigned-title-itm overflow-ellipsis2 fst_line2"
                        title={row.qualificationName ? row.qualificationName : "-"}
                        style={{ cursor: "pointer" }}
                    >
                        <Link
                            className="as-text-blue curser textLimit150"
                            title={row.qualificationName}
                            target="_blank"
                            to={`/courseAdministration/Programmes/programme/open/${row.qualification_id}/details`}
                        >
                            {row.qualificationName ? row.qualificationName : "-"}
                        </Link>
                    </div>
                </div>
            ),
        },
        {
            name: "Intake",
            selector: "year",
            sortable: true,
            sortField: "intake",
            cell: (row) => (
                <p>
                    {row.year || row.number ? (
                        <>
                            {" "}
                            {row.year ? row.year : ""}-{row.number ? row["number"] : ""}
                        </>
                    ) : (
                        "-"
                    )}
                </p>
            ),
        },
        {
            name: "School",
            selector: "school_type",
            sortable: true,
            sortField: "school_type",
            cell: (row) => <span className='textLimit75 width-155'>{row.school_type ? RenderSchool(row.school_type).html : "-"}</span>
        },
        {
            name: "Type",
            selector: "subject_type",
            sortable: true,
            sortField: "subject_type",
            cell: (row) => row.subject_type ? RenderCourseType(row.subject_type).html : "-"
        },
        {
            name: "Actions",
            selector: "",
            cell: (row) => row.isGroupHeader ? null : (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        {linkCheckedAllRows.includes(row?.id) ?
                            <PermissionsGate scopes={["caaunlinkcourse"]} errorProps={{ disabled: true }}>
                                <button
                                    type="button"
                                    className="btn btn-danger rounded-circle" title="Remove Course"
                                    onClick={() => {
                                        Swal.fire({
                                            title: "Are you sure?",
                                            text: "You want to unassign this course!",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes",
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                setLinkCourseData(linkCourseData.filter((course) => course.id !== row?.id))
                                                // Remove from checked rows
                                                setLinkCheckedAllRows(linkCheckedAllRows.filter((id) => id !== row?.id));
                                            }
                                        })
                                    }}
                                >
                                    <i className="fal fa-minus"></i>
                                </button>
                            </PermissionsGate>
                            : <PermissionsGate scopes={["caalinkcourse"]} errorProps={{ disabled: true }}>
                                <button
                                    type="button"
                                    className="btn btn-primary rounded-circle"
                                    title="Add Course"
                                    onClick={() => {
                                        const modifiedRow = { ...row, newData: true, selectedTemplate: {}, weight: "" };
                                        setLinkCourseData((prev) => [...prev, modifiedRow]);
                                        setLinkCheckedAllRows((prev) => [...prev, row?.id]);
                                    }}
                                >
                                    <i className="fal fa-plus"></i>
                                </button>
                            </PermissionsGate>
                        }

                        <Link
                            className="btn btn-primary h-auto rounded-circle"
                            // onClick={() => modalClose()}
                            target="_blank"
                            to={`/courseAdministration/coursesdetails/${row.id}/detailCourses/show`}
                            title="Open"
                        >
                            <i className="fal fa-folder-open"></i>
                        </Link>
                    </div>
                </div>
            )
        }
    ]);

    const getCourses = () => {
        setLoading(true)

        const cancelTokenSources = [];
        cancelTokenSources.forEach(source => {
            source.cancel('New request made');
        });

        const source = axios.CancelToken.source();
        cancelTokenSources.push(source);

        let data = {
            pageNo: tableState.page,
            size: tableState.perPage,
            intake: intake.arr,
            viaLearnType: learningMethod.arr,
            key: tableState.sortKey,
            sort: tableState.sortOrder,
            viaStatus: [],
            viaLinkedIntake: 1,
            viaSearch: search,
            viaProgramme: programmeIds.arr,
            viaSchoolType: school.arr,
            viaSubjectType: courseType.arr?.length > 0 ? courseType.arr : [],
            viaStartDate: courseStartDate ? moment(courseStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaEndDate: courseEndDate ? moment(courseEndDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaRangeStartDate: courseDateRange?.startDate && courseDateRange?.endDate ? moment(courseDateRange?.startDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            viaRangeEndDate: courseDateRange?.startDate && courseDateRange?.endDate ? moment(courseDateRange?.endDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
            // showing: [],
            hasNoAssignedIntake: 1,
            assessment_id: (formik?.values?.AssessmentType == 9 && type == "add") ? sickAssessmentId : subId,
            intake_id: id,
        };

        GetCoursesToLink(data, source.token).then(res => {
            setCourseData(res?.data?.data?.data);
            setTotalRows(res?.data?.pagination?.total);
        }).catch(err => {
            console.error("error :", err)
        }).finally(() => {
            setLoading(false)
        })
    }
    
    useEffect(() => {
        getCourses();
    }, [tableState.page, tableState.perPage, tableState.sortKey, tableState.sortOrder, intake.arr, learningMethod.arr, programmeIds.arr, school.arr, courseType.arr, search, courseStartDate, courseEndDate, courseDateRange, handleRefreshCourseList])

    const dataTableComponentFilters = [
        {
            filterName: "Learning Method",
            optionArr: courseDropdown.learning || [],
            state: learningMethod,
            setState: setLearningMethod,
            renderLabelFunction: RenderLearningMethod,
        },
        {
            filterName: "Programme",
            optionArr: courseDropdown.programme || [],
            state: programmeIds,
            setState: setProgrammeIds,
            isSearchFilter: true,
        },
        {
            filterName: "Intake",
            optionArr: courseDropdown.intake || [],
            state: intake,
            setState: setIntake,
            isOptionReversed: true
        },
        {
            filterName: "School",
            optionArr: courseDropdown.school || [],
            state: school,
            setState: setSchool,
            renderLabelFunction: RenderSchool,
            isOptionReversed: false,
            stopOptionSorting: true
        },
        {
            filterName: "Type",
            optionArr: courseDropdown.type || [],
            state: courseType,
            setState: setCourseType,
            renderLabelFunction: RenderCourseType,
            isOptionReversed: false,
            stopOptionSorting: true
        },
        {
            filterName: "Start Date",
            state: courseStartDate,
            setState: setCourseStartDate,
            dateFilter: true,
            notReset: true
        },
        {
            filterName: "End Date",
            state: courseEndDate,
            setState: setCourseEndDate,
            dateFilter: true,
            notReset: true
        },
        {
            filterName: "Date Range",
            state: courseDateRange,
            setState: setCourseDateRange,
            dateRangeFilter: true
        }
    ].filter(item => item);

    return (
        <div
            className={`link-course-modal modal fade mt-1`}
            id="link-course-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
        >
            <div
                className="modal-dialog modal-dialog-centered available-assessment-modal"
                role="document"
                style={{ width: "73%" }}
            >
                <div className="modal-content modal-border-update">

                    <div className="modal-body p-0">
                        <div className="modal-header modal-header-custom">
                            <h5 className="modal-title">
                                <i className="fal fa-link"></i> Link Course
                            </h5>
                            <button
                                type="button"
                                className="close"
                                onClick={() => modalClose()}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="p-30px">
                            <DataTableComponent
                                data={courseData}
                                loading={loading}
                                state={tableState}
                                setState={setTableState}
                                setSearch={setSearch}
                                totalRows={totalRows}
                                columns={columns}
                                exportFunction={exportData}
                                exportFileName={"available_course_list"}
                                resetModal={resetModal}
                                setResetModal={setResetModal}
                                filters={dataTableComponentFilters}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LinkCourseModal